import { WorkOrderTable } from "../components/WorkOrderTable.js";

export const WorkOrdersPage = () => {
  return <WorkOrderTable />;
};
